import React, { useState } from 'react';
import Modal from '../Modal';
import { useSocieta } from '../../context/SocietaContext';
import FormTicket, { FormTicketValori, formTicketIniziale, inviaTicket, validaFormTicket } from './FormTicket';

// Modale classica di apertura ticket: usata quando l'assistente non è
// configurato o non risponde. `iniziale` precompila i campi.

interface Props {
  iniziale?: Partial<FormTicketValori>;
  chatId?: number | null;
  onClose: () => void;
  onCreato: (id: number) => void;
}

export default function ModalNuovoTicket({ iniziale, chatId, onClose, onCreato }: Props) {
  const { societaAttiva } = useSocieta();
  const [valori, setValori] = useState<FormTicketValori>({ ...formTicketIniziale, ...iniziale });
  const [errore, setErrore] = useState('');
  const [saving, setSaving] = useState(false);

  const salva = async () => {
    const msg = validaFormTicket(valori);
    if (msg) { setErrore(msg); return; }
    setSaving(true); setErrore('');
    try {
      const id = await inviaTicket(valori, societaAttiva?.id ?? null, chatId);
      onCreato(id);
    } catch (e: any) {
      setErrore(e.message || 'Errore nell\'invio della richiesta');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Nuova richiesta di assistenza"
      size="lg"
      onClose={onClose}
      footer={
        <>
          <button className="bop-btn bop-btn-secondary" onClick={onClose}>Annulla</button>
          <button className="bop-btn bop-btn-primary" onClick={salva} disabled={saving}>{saving ? 'Invio…' : 'Invia richiesta'}</button>
        </>
      }
    >
      {errore && <div className="bop-inline-error">{errore}</div>}
      <FormTicket valori={valori} onChange={setValori} autoFocus />
    </Modal>
  );
}
